import axios from 'axios';
import { useAuthStore } from '../store/authStore';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const getToken = () => useAuthStore.getState().token;
const authHeaders = () => ({ headers: { Authorization: `Bearer ${getToken()}` } });

export type ConsentScope = 'research' | 'analytics' | 'data_sharing';
export type ConsentStatus = 'granted' | 'declined' | 'withdrawn' | 'not_asked';

export interface ConsentNotice {
  version: string;
  title: string;
  summary: string;
  points: string[];
}

export interface ConsentScopeState {
  scope: ConsentScope;
  status: ConsentStatus;
  decidedAt: string | null;
  noticeVersion: string | null;
  needsReconfirm: boolean;
}

export interface MyConsent {
  noticeVersion: string;
  scopes: ConsentScopeState[];
}

export interface ConsentCoverage {
  totalStudents: number;
  noticeVersion: string;
  scopes: Array<{
    scope: ConsentScope;
    granted: number;
    declined: number;
    withdrawn: number;
    notAsked: number;
    coverageRate: number;
    researchReady: boolean;
  }>;
}

export const consentApi = {
  getNotice: async (): Promise<ConsentNotice> => {
    const res = await axios.get(`${API_BASE_URL}/consent/notice`);
    return res.data.data;
  },

  getMine: async (): Promise<MyConsent> => {
    const res = await axios.get(`${API_BASE_URL}/consent/me`, authHeaders());
    return res.data.data;
  },

  /**
   * Record the caller's own decision. There is no userId parameter by design:
   * only the participant may decide.
   */
  record: async (scope: ConsentScope, status: 'granted' | 'declined' | 'withdrawn') => {
    const res = await axios.post(`${API_BASE_URL}/consent`, { scope, status }, authHeaders());
    return res.data;
  },

  getCoverage: async (): Promise<ConsentCoverage> => {
    const res = await axios.get(`${API_BASE_URL}/consent/coverage`, authHeaders());
    return res.data.data;
  }
};

export default consentApi;
